import { AxiosRequestConfig } from 'axios';
import axiosClient from './request-client';

export const runTask = (
  taskName: string,
  { avoidResponse, queue, ...payload }: Record<string, unknown>,
  config?: AxiosRequestConfig
) =>
  axiosClient.post(
    `/tasks`,
    {
      taskName,
      payload,
      avoidResponse,
      queue,
    },
    {
      headers: {
        ...config?.headers,
      },
    }
  );

export type TaskJobState =
  | 'completed'
  | 'failed'
  | 'active'
  | 'waiting'
  | 'delayed'
  | 'paused'
  | 'unknown'
  | 'waiting-children'
  | 'prioritized';

export type TaskJobStatus = {
  jobId: string;
  taskName: string;
  state: TaskJobState;
  progress: number | object;
  attemptsMade: number;
  returnvalue: Record<string, unknown> | null;
  failedReason: string | null;
  finishedOn: number | null;
  processedOn: number | null;
};

export const getTaskJob = (jobId: string, config?: AxiosRequestConfig) =>
  axiosClient.get<{ data: TaskJobStatus }>(`/tasks/queue/jobs/${jobId}`, {
    headers: {
      ...config?.headers,
    },
  });
